<template>
    <section class="section register-form">
        <div class="ingreso">
            <div class="card">
                <div class="card-header-title is-size-3 pt-2 has-text-primary">
                    Ingresa tu nueva clave
                </div>
                <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
                    <div class="card-content columns is-multiline">
                        <div class="field column is-6 mb-6">
                            <label class="label has-text-weight-semibold">
                                Ingresar clave
                            </label>
                            <Input
                                rules="required"
                                type="password"
                                ref="password"
                                name="password"
                                minlength="4"
                                maxlength="64"
                                placeholder="*********"
                                vid="password"
                                v-model="user.password"
                                autocomplete="new-password"
                                :is-password="true"
                                :safe-password="true"
                            />
                        </div>
                        <div class="column is-6 field mb-6">
                            <label class="label has-text-weight-semibold">
                                Repetir Clave
                            </label>
                            <Input
                                rules="required|confirmed:password"
                                name="password"
                                type="password"
                                placeholder="*********"
                                v-model="password_confirmation"
                                v-on:keyup.native.enter="handleSubmit(submitForm)"
                                :is-password="true"
                            />
                        </div>
                        <div class="column is-12 field mb-3 mt-3">
                            <button
                                class="button is-fullwidth is-primary"
                                :disabled="loading"
                                v-on:click.prevent="handleSubmit(submitForm)"
                            >
                                Cambiar clave
                            </button>
                        </div>
                    </div>
                </ValidationObserver>
            </div>
        </div>
    </section>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import Input from "@/components/inputs/Input";
import { changePassword } from "@/api/security";
import { mapState } from "vuex";
import { consoleHandlerError } from "@/utils/message";

export default {
    name: "FormRecovery",
    components: {
        Input,
        ValidationObserver,
    },
    data: function() {
        return {
            errors: [],
            loading: false,
            password_confirmation: "",
            user: {
                token: "",
                password: "",
            },
            publicPath: window.location.hostname,
        };
    },
    methods: {
        submitForm() {
            this.loading = true;
            this.user.token = this.recoveryToken;
            changePassword(this.user)
                .then(() => {
                    this.loading = false;
                    this.$router.push("/");
                })
                .catch((error) => {
                    this.loading = false;
                    consoleHandlerError({ error, empty: true });
                });
        },
    },
    computed: {
        ...mapState("userAuth", ["recoveryToken"]),
    },
};
</script>
